import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const namespaced = true;
const state = {
    user: null,
    isLogin: false,

};

export const vipBirth = {
    namespaced,
    state,
    getters,
    actions,
    mutations,
};
